export interface Vehicle {
  id: string;
  brand: string;
  model: string;
  version: string;
  year: string;
  km: string;
  price: number;
  engine: string;
  power: string;
  transmission: string;
  armored: boolean;
  image: string;
  badge?: string;
}

export interface MaintenanceRecord {
  id: string;
  date: string;
  service: string;
  mileage: string;
  status: 'Concluído' | 'Agendado';
  cost: number;
}

export const automoveisStock: Vehicle[] = [
  {
    id: 'car_001',
    brand: 'Porsche',
    model: '911 Carrera S',
    version: '3.0 24V Twin-Turbo',
    year: '2024/2024',
    km: '4.200 km',
    price: 1250000,
    engine: '3.0 Boxer Turbo',
    power: '450 cv',
    transmission: 'PDK 8 Marchas',
    armored: false,
    image: 'https://images.unsplash.com/photo-1614162692292-7ac56d7f7f1e?q=80&w=800&auto=format&fit=crop',
    badge: '🔥 Destaque do Mes'
  },
  {
    id: 'car_002',
    brand: 'BMW',
    model: 'M3 Competition',
    version: '3.0 TwinPower Turbo',
    year: '2023/2024',
    km: '11.000 km',
    price: 790000,
    engine: '3.0 I6 Bi-Turbo',
    power: '510 cv',
    transmission: 'M Steptronic 8M',
    armored: true,
    image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?q=80&w=800&auto=format&fit=crop',
    badge: '🛡️ Blindado III-A'
  },
  {
    id: 'car_003',
    brand: 'Audi',
    model: 'RS6 Avant',
    version: '4.0 V8 Bi-Turbo MHEV',
    year: '2023/2023',
    km: '18.500 km',
    price: 980000,
    engine: '4.0 V8 Bi-Turbo',
    power: '600 cv',
    transmission: 'Tiptronic 8M',
    armored: false,
    image: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'car_004',
    brand: 'Mercedes-AMG',
    model: 'G 63',
    version: '4.0 V8 Bi-Turbo V8',
    year: '2022/2023',
    km: '22.000 km',
    price: 1680000,
    engine: '4.0 V8 Bi-Turbo',
    power: '585 cv',
    transmission: 'AMG SPEEDSHIFT 9M',
    armored: true,
    image: 'https://images.unsplash.com/photo-1520050206274-a1ae44613e6d?q=80&w=800&auto=format&fit=crop',
    badge: '🛡️ Blindado III-A'
  }
];

export const historicoManutencao: MaintenanceRecord[] = [
  {
    id: 'srv_01',
    date: '10/05/2026',
    service: 'Revisão de 10.000km + Troca de Óleo Mobil 1 Synthetic',
    mileage: '10.200 km',
    status: 'Concluído',
    cost: 3400.00
  },
  {
    id: 'srv_02',
    date: '15/11/2026',
    service: 'Agendamento: Troca de Pastilhas de Freio de Cerâmica',
    mileage: '15.000 km',
    status: 'Agendado',
    cost: 8200.00
  }
];
